import { render, staticRenderFns } from "./EiLongFigureScrollForPerson.vue?vue&type=template&id=7f0e51f6&scoped=true&"
import script from "./EiLongFigureScrollForPerson.vue?vue&type=script&lang=js&"
export * from "./EiLongFigureScrollForPerson.vue?vue&type=script&lang=js&"
import style0 from "./EiLongFigureScrollForPerson.vue?vue&type=style&index=0&id=7f0e51f6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f0e51f6",
  null
  
)

export default component.exports